/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormulasManagerDto } from './FormulasManagerDto';
import {
    FormulasManagerDtoFromJSON,
    FormulasManagerDtoFromJSONTyped,
    FormulasManagerDtoToJSON,
    FormulasManagerDtoToJSONTyped,
} from './FormulasManagerDto';

/**
 * What the formula cards need about the file's person to say who each formula is for
 * ("for the company" / "for the manager: First Last"). Only sent when formulas are shown.
 * 
 * @export
 * @interface FormulasContextDto
 */
export interface FormulasContextDto {
    /**
     * 
     * @type {boolean}
     * @memberof FormulasContextDto
     */
    insuredIsLegalEntity: boolean;
    /**
     * Manager of the legal entity; null for an individual or when no manager is recorded.
     * @type {FormulasManagerDto}
     * @memberof FormulasContextDto
     */
    manager?: FormulasManagerDto | null;
}

/**
 * Check if a given object implements the FormulasContextDto interface.
 */
export function instanceOfFormulasContextDto(value: object): value is FormulasContextDto {
    if (!('insuredIsLegalEntity' in value) || value['insuredIsLegalEntity'] === undefined) return false;
    return true;
}

export function FormulasContextDtoFromJSON(json: any): FormulasContextDto {
    return FormulasContextDtoFromJSONTyped(json, false);
}

export function FormulasContextDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulasContextDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insuredIsLegalEntity': json['insuredIsLegalEntity'],
        'manager': json['manager'] == null ? undefined : FormulasManagerDtoFromJSON(json['manager']),
    };
}

export function FormulasContextDtoToJSON(json: any): FormulasContextDto {
    return FormulasContextDtoToJSONTyped(json, false);
}

export function FormulasContextDtoToJSONTyped(value?: FormulasContextDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insuredIsLegalEntity': value['insuredIsLegalEntity'],
        'manager': FormulasManagerDtoToJSON(value['manager']),
    };
}

